export default __webpack_public_path__ + "5de0643bf1bbf77878ff26e8d04f3042.png";